<template>
  <div class="unknown-error-page">
    <div class="emoji ri-large-display">
      🤦‍♂️
    </div>
    <div class="ri-medium-bold-headline padding-top-l">
      Something is wrong
    </div>
    <div class="ri-body padding-top-l">
      Please refresh or come back later
    </div>
  </div>
</template>

<script lang="ts" setup>

</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';
@import '@riseupil/base-ui/src/scss/mixins';

  .unknown-error-page {
    margin: 40px 35px 30px;
    text-align: center;
    .emoji {
      margin-top: 120px;
    }
  }
</style>
